import { render, staticRenderFns } from "./vc-progress.vue?vue&type=template&id=679f0e8d&scoped=true&"
import script from "./vc-progress.vue?vue&type=script&lang=js&"
export * from "./vc-progress.vue?vue&type=script&lang=js&"
import style0 from "./vc-progress.vue?vue&type=style&index=0&id=679f0e8d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f0e8d",
  null
  
)

export default component.exports